export default __webpack_public_path__ + "static/media/earned.b923a0f5.svg";